'use client';

import { AppBreadcrumbs } from '@kit/ui/app-breadcrumbs';
import { SidebarTrigger } from '@kit/ui/shadcn-sidebar';
import { cn } from '@kit/ui/utils';

import { useBreadcrumbTitles } from './breadcrumb-titles-context';

/**
 * The single breadcrumb + sidebar-collapse row, rendered once per shell
 * directly beneath the fixed top bar. Replaces both the top-bar
 * `TopBarBreadcrumbs` (pathname-only, poor titles) and the per-shell
 * sidebar-header toggles — the whole app now has ONE breadcrumb and ONE
 * collapse control, here. Data-derived titles come from
 * `BreadcrumbTitlesProvider` (detail pages register their record title);
 * everything else falls back to `AppBreadcrumbs`' pathname humanization.
 *
 * Desktop-only (the mobile shells use the bottom tab bar, no sidebar).
 */
export function AppBreadcrumbBar({ className }: { className?: string }) {
  const titles = useBreadcrumbTitles();

  return (
    <div
      className={cn(
        'text-muted-foreground hidden items-center gap-x-2.5 px-4 py-2.5 md:flex lg:px-6',
        className,
      )}
    >
      <SidebarTrigger className="hover:text-foreground size-4.5 shrink-0 cursor-pointer" />
      <AppBreadcrumbs
        values={Object.keys(titles).length ? titles : undefined}
      />
    </div>
  );
}
